/** Pricing command errors every proposal kind answers with the same body. */
export const PRICING_SUPERSEDED_CODE = `PRICING_SUPERSEDED`

export const PRICING_SUPERSEDED_MESSAGE = `Pricing changed while calculating. Refresh again after you finish editing.`

/** The `error` code of an axios-shaped error body, when it carries one. */
export const responseErrorCode = (error: unknown): unknown => {
  if (error == null || typeof error !== `object` || !(`response` in error)) {
    return undefined
  }

  const { response } = error
  if (
    response == null ||
    typeof response !== `object` ||
    !(`data` in response)
  ) {
    return undefined
  }

  const { data } = response
  if (data == null || typeof data !== `object` || !(`error` in data)) {
    return undefined
  }

  return data.error
}

export const isPricingSupersededError = (error: unknown): boolean =>
  responseErrorCode(error) === PRICING_SUPERSEDED_CODE
